import * as React from 'react';
import classnames from 'classnames';
import { Tooltip } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { stockResolver } from './helpers.js';
import { useStockIndicator } from './StockIndicatorContext.js';

const inventoryClassNames = {
    inStock: 'in-stock',
    lowStock: 'low-stock',
    veryLowStock: 'very-low-stock',
    outOfStock: 'out-of-stock',
    backOrder: 'back-order',
    availableInStore: 'available-in-store'
};
const StockIndicator = ({ stockCount , allowBackOrder =true , channelAvailability ='IN_STORE_ONLY' ,  })=>{
    const { getLabel  } = useIntl();
    const { thresholds  } = useStockIndicator();
    const stock = stockResolver(channelAvailability, allowBackOrder, stockCount, thresholds);
    if (!stock) {
        return null;
    }
    const { labelId , tooltipId  } = stock;
    const shouldShowTooltip = tooltipId || labelId === 'backOrder';
    const inventoryClass = labelId.substr(labelId.lastIndexOf('.') + 1);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('stock-indicator', {
            [`stock-indicator--level-${inventoryClassNames[inventoryClass]}`]: inventoryClassNames[inventoryClass]
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "stock-indicator__levels"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "stock-indicator__levels-level"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "stock-indicator__label"
    }, getLabel(`products.stockInfo.${labelId}`)), shouldShowTooltip && /*#__PURE__*/ React.createElement(Tooltip, {
        id: "stock-indicator",
        className: "stock-indicator__tooltip",
        // All stock levels can have a tooltip when configured through a custom config
        // inStockTooltip, lowStockTooltip, veryLowStockTooltip, outOfStockTooltip, backOrderTooltip
        message: getLabel(`products.stockInfo.${tooltipId || 'backOrder'}Tooltip`),
        placement: "right"
    }));
};
var StockIndicator$1 = StockIndicator;

export { StockIndicator, StockIndicator$1 as default };
//# sourceMappingURL=StockIndicator.js.map
